import React, { useState } from 'react';
import moment from 'moment';
import { gtmPush } from '../../../lib/gtm';
import Button from '../../../audi-ui-components/Button';
import IconCalendarEvents from '../../../audi-ui-components/icons/CalendarEvents';
import CaretDown from '../../../audi-ui-components/icons/CaretDown';
import CaretUp from '../../../audi-ui-components/icons/CaretUp';
import NavBar from '../../../audi-ui-components/NavBar';
import TickGreen from '../../../audi-ui-components/icons/TickGreen';

const ServicePlan = ({ servicePlanDetails, setActiveModal, preferredServiceLocation }) => {

    const [activeTab, setActiveTab] = useState(0);

    const currentPlans = servicePlanDetails?.filter(w => w.planStatus === 'Active') || [];
    const pastPlans = servicePlanDetails?.filter(w => w.planStatus !== 'Active') || [];

    const tabActions = [];
    if (currentPlans.length > 0) tabActions.push({ label: 'Active' });
    if (pastPlans.length > 0) tabActions.push({ label: 'Inactive' });

    const currentTabIndex = currentPlans.length > 0 ? 0 : -1;
    const pastTabIndex = currentPlans.length > 0 && pastPlans.length > 0 ? 1 : (pastPlans.length > 0 ? 0 : -1);

    return (
        <div className="col-12 col-medium-6 pb-3 vehicle-details">
            <div className="aui-color-gray95 mt-3 mb-3 pb-5" style={{ height: '100%' }}>
                <div className="row h-100">

                    <div className="col-12 panel">
                        <div className="py-4">
                            <div className="col-12 px-6">
                                <IconCalendarEvents />
                            </div>
                            <div className="col-12 px-6">
                                <h2 className="aui-headline-3"><b>Audi Service Plan</b></h2>
                            </div>

                            <div className="col-12 px-6 description">
                                This plan covers all scheduled servicing to ensure your Audi performs at its peak.
                            </div>

                            <div className="col-12 px-6">
                                {(!Array.isArray(servicePlanDetails) || servicePlanDetails.length === 0) && (
                                    <div className="pt-3">No service plan found for this vehicle.</div>
                                )}
                                {servicePlanDetails && servicePlanDetails.length > 0 && (
                                    <>
                                        <NavBar
                                            actions={tabActions}
                                            activeIndex={activeTab}
                                            onActionClick={(idx) => setActiveTab(idx)}
                                            navType="tab"
                                            className="recalls-nav mb-4"
                                        />

                                        {activeTab === currentTabIndex && currentPlans.length > 0 && (
                                            <div className="status-group mb-5" style={{ marginTop: '2rem' }}>
                                                {currentPlans.map((w, idx) => (
                                                    <div key={'servicePlan-current-' + idx} className="mt-3 details-accordion">
                                                        <details onToggle={(e) => { if (e.currentTarget.open) gtmPush("myAudi_click", "serviceplan_accordian", "service_plan_active"); }}>
                                                            <summary>
                                                                <div className="title">
                                                                    <span className="label-wrap">
                                                                        <TickGreen small style={{ marginRight: '8px', flexShrink: 0 }} />
                                                                        <span className="label">Service Plan Type</span>
                                                                    </span>
                                                                    <span className="value">{w.planType}</span>
                                                                </div>
                                                                <div className="carets">
                                                                    <CaretDown className="down" small />
                                                                    <CaretUp className="up" small />
                                                                </div>
                                                            </summary>
                                                            <div className="item">
                                                                <span className="label">Remaining Services</span>
                                                                <span className="value">{w.servicesRemaining}</span>
                                                            </div>
                                                            <div className="item">
                                                                <span className="label">Status</span>
                                                                <span className="value">{w.planStatus}</span>
                                                            </div>
                                                        </details>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {activeTab === pastTabIndex && pastPlans.length > 0 && (
                                            <div className="status-group mb-5" style={{ marginTop: '2rem' }}>
                                                {pastPlans.map((w, idx) => (
                                                    <div key={'servicePlan-past-' + idx} className="mt-3 details-accordion">
                                                        <details onToggle={(e) => { if (e.currentTarget.open) gtmPush("myAudi_click", "serviceplan_accordian", "service_plan_inactive"); }}>
                                                            <summary>
                                                                <div className="title">
                                                                    <span className="label">Service Plan Type</span>
                                                                    <span className="value">{w.planType}</span>
                                                                </div>
                                                                <div className="carets">
                                                                    <CaretDown className="down" small />
                                                                    <CaretUp className="up" small />
                                                                </div>
                                                            </summary>
                                                            <div className="item">
                                                                <span className="label">Remaining Services</span>
                                                                <span className="value">{w.servicesRemaining}</span>
                                                            </div>
                                                            <div className="item">
                                                                <span className="label">Status</span>
                                                                <span className="value">{w.planStatus}</span>
                                                            </div>
                                                        </details>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                        </div>
                        <div className="">
                            <div className="buttons px-6">
                                <Button variant="primary" className="" href={`https://forms.audi.com.au/book-a-service${preferredServiceLocation?.dealer?.dealerCode ? `/${preferredServiceLocation.dealer.dealerCode}` : ''}`} target="_blank" onClick={() => gtmPush("myAudi_click", "bookaservice", "Service plan cta click")}>Book a service</Button>
                                <Button variant="secondary" className="" onClick={() => { setActiveModal('buy-service-plan'); }}>Get a top up service plan</Button>
                            </div>
                            <div className="px-6 mt-4 note disclaimer">Disclaimer: Audi Service Interval is every 15,000km or 12 Months (whichever occurs first) from the Warranty Start Date.</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
};

export default ServicePlan;
